import React from 'react'
import './Loader.css'
function Loader() {
  return (
    <div className="Loader-Container">
        <span class="loader"></span>
        <h2 class="loader-lable">Getting Contests Details</h2>
    </div>
  )
}

export default Loader